<script>
  import { onMount } from 'svelte';
  let pathSuffix = "/app/apptoweb"
  let isApptoWeb = false
  onMount(()=> {
    pathSuffix = location.pathname.includes("apptoweb") ? "/app/apptoweb" : "";
    isApptoWeb = location.pathname.includes("apptoweb") ? isApptoWeb = true : isApptoWeb = false;
  })
</script>
<page-header text="デビットカードの基本"></page-header>
  <keyvisual-content
    title="タッチ決済も<br>ネットショッピングもできる"
    image="/assets_default/images/service/debit-card/guide/about/service_debit-card_guide_about_kv.webp"
  >
  </keyvisual-content>
  <section class="owd-section spacing:bottom:64">
    <h2 class="owd-heading:03 align:center spacing:bottom:24">デビットカードとは？</h2>

    <div class="owd-servicelist:wrapper bg-colors:light-gray">
      <p class="owd-heading:05 spacing:bottom:12">銀行口座の残高の範囲内で使える</p>
      <p class="owd-caption spacing:bottom:20">デビットカードは口座の残高の範囲内で、お買い物ができます。</p>
      <p class="owd-heading:05 spacing:bottom:12">即時引落し</p>
      <p class="owd-caption">クレジットカードと違ってお買い物すると口座から即時引落しされます。</p>
    </div>
  </section>
  <section class="owd-section spacing:bottom:64">
    <h2 class="owd-heading:03 spacing:bottom:24">クレジットカード、現金との違い</h2>
    <div class="owd-wrap:overflow spacing:bottom:12">
      <div class="owd-table owd-table:scroll">
        <table style="min-width: 532px;">
          <!-- data-scrolltable-min="532" -->
          <thead>
            <tr>
              <th style="width: calc((115/532)*100%);"></th>
              <th class="owd-sf:accent" style="width: calc((140/532)*100%);"><strong>デビットカード</strong></th>
              <th><strong>クレジットカード</strong></th>
              <th><strong>現金</strong></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th><strong>特徴</strong></th>
              <td class="owd-sf:lightyellow">即時引落しなので、使いすぎを防ぎながら、支払いできる</td>
              <td>請求が遅れてくるため、支出が把握しづらく使いすぎてしまう</td>
              <td>現金の引出しやレシートの管理、家計簿をつけるのが手間</td>
            </tr>
            <tr>
              <th><strong>年齢</strong></th>
              <td class="owd-sf:lightyellow">15歳から作れる<sup>※1</sup></td>
              <td>18歳から作れる<sup>※1</sup></td>
              <td>誰でもすぐに支払い可能</td>
            </tr>
            <tr>
              <th><strong>キャッシュレス<br>対応</strong></th>
              <td class="owd-sf:lightyellow"><img class="owd-table-icon" src="{pathSuffix}/assets_default/icons/circle.svg" alt="丸アイコン"></td>
              <td><img class="owd-table-icon" src="{pathSuffix}/assets_default/icons/circle.svg" alt="丸アイコン"></td>
              <td><img class="owd-table-icon" src="{pathSuffix}/assets_default/icons/cross.svg" alt="バツアイコン"></td>
            </tr>
            <tr>
              <th><strong>支出の把握の<br>しやすさ</strong></th>
              <td class="owd-sf:lightyellow">即時決済で残高が減るから支出を把握しやすい</td>
              <td>後払いで支出が把握しづらい</td>
              <td>支出把握はレシート管理や家計簿が必要</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <ul class="owd-list:annotation:number">
      <li>
        <span class="owd-list:annotation:number-text" data-annotation-number="1">発行会社によって条件は異なります。</span>
      </li>
    </ul>
  </section>
  <section class="owd-section spacing:bottom:64">
    <h2 class="owd-heading:03 align:center spacing:bottom:24">こんな方におすすめ</h2>
    <p class="owd-text:01 spacing:bottom:24">みんなの銀行では、口座開設をすると同時にバーチャルデビットが発行されるので、申込み不要ですぐに使えます。</p>
    <div class="owd-servicelist:wrapper bg-colors:light-gray spacing:bottom:24">
      <ul class="owd-list:colmun-icon">
        <li class="owd-list:colmun-icon:check"><span class="{isApptoWeb ? "checkmark":""}"><strong>ついつい使いすぎてしまう</strong></span></li>
        <li class="owd-list:colmun-icon:check"><span class="{isApptoWeb ? "checkmark":""}"><strong>タッチ決済で素早く支払いたい</strong></span></li>
        <li class="owd-list:colmun-icon:check"><span class="{isApptoWeb ? "checkmark":""}"><strong>お金の管理をかんたんにしたい</strong></span></li>
      </ul>
    </div>
    <div class="owd-servicelist:wrapper bg-colors:light-gray spacing:bottom:24">
      <p class="owd-heading:05 spacing:bottom:6">最大1.0%が現金で還元</p>
      <p class="owd-caption">デビットカードで支払うと、利用金額の0.2%が現金として還元され、プレミアム会員なら還元率が1.0%に。</p>
      <div class="show:sp">
        <div class="spacing:bottom:16"></div>
        <div class="block:center spacing:bottom:16">
          <a href="https://minna-no-ginko.go.link/?tp=pg&pg=st&adj_t=1tyj1kia" class="owd-button owd-button:large owd-button:secondary:white">プレミアムサービスを申込む</a>
        </div>
        <p class="owd-information align:center"><strong>※アプリをお持ちでない方は、ストアに遷移します。</strong></p>
      </div>
    </div>
  </section>
  <section class="owd-section spacing:bottom:64">
    <ul class="owd-framedlinklist spacing:bottom:64 modal-none">
      <li class="owd-framedlinklist-item spacing:bottom:12">
        <a href="/service/debit-card/guide/howto/" class="owd-framedlinklist-flex">
          <div>
            <p class="owd-heading:04 spacing:bottom:12">デビットカードの使い方</p>
            <p class="owd-text:02">まずは使う金額を口座に入金</p>
          </div>
          <img src="{pathSuffix}/assets_default/icons/chevron_right.svg" alt="右矢印アイコン">
        </a>
      </li>
      <li class="owd-framedlinklist-item">
        <a href="/service/debit-card/guide/place/" class="owd-framedlinklist-flex">
          <div>
            <p class="owd-heading:04 spacing:bottom:12">使える場所</p>
            <p class="owd-text:02">全国のコンビニやスーパーなどあらゆる場所で利用できます</p>
          </div>
          <img src="{pathSuffix}/assets_default/icons/chevron_right.svg" alt="右矢印アイコン">
        </a>
      </li>
    </ul>

    <ul class="owd-list:mix:01">
      <li>
        <p class="owd-heading:05 spacing:bottom:16">申込みに関する注意事項</p>
        <ul class="owd-list:annotation">
          <li>口座開設と同時にアプリ内に自動発行されます。なお、メルカリ支店を利用中の方は、口座開設と同時にバーチャルデビットが発行されません。みんなの銀行アプリをダウンロード後、アプリから申込みが必要です。</li>
          <li>申込みの際、発行審査にお時間がかかる場合があります。</li>
          <li>申込みの結果、デビットカードの発行をお断りさせていただく場合があります。その場合、お断りの理由は回答いたしかねます。</li>
          <li>追加口座ではデビットカードを発行できません。</li>
        </ul>
      </li>
      <li>
        <p class="owd-heading:05 spacing:bottom:16">お店で支払いする場合の注意事項</p>
        <ul class="owd-list:annotation">
          <li>利用のスマートフォンがタッチ決済可能な端末であり、タッチ決済に対応しているお店で利用できます。</li>
          <li>QUICPay™（クイックペイ）はApple Pay、Google Pay に対応しています。</li>
          <li>JCBのタッチ決済はApple Payに対応しています。</li>
          <li>利用の機種に応じ、支払い時の操作が異なります。iPhoneを利用の場合は<a class="owd-textlink:blank" href="https://www.quicpay.jp/guide/iphone/howto.html" target="_blank">こちら</a>を確認してください。Android™ を利用の場合は<a class="owd-textlink:blank" href="https://www.quicpay.jp/guide/android/howto.html" target="_blank">こちら</a>を確認してください。</li>
          <li>お持ちのスマートフォンによっては、顔認証や指紋認証が求められる場合があります。</li>
          <li>Apple Payを利用するには最新バージョンのiOSが必要です。Apple Payに対応しているデバイスについては<a class="owd-textlink:blank" href="https://support.apple.com/ja-jp/102896" target="_blank">こちら</a>を確認してください。</li>
          <li>Apple Payは、米国およびほかの国々で登録されたApple Inc. の商標です。</li>
          <li>Google Pay は、Google ウォレットアプリをダウンロードできるスマートフォンで使えます。Android OSのバージョンは、<a class="owd-textlink:blank" href="https://support.google.com/wallet/answer/13314575" target="_blank">Google ウォレットのサポートページ</a>を確認してください。</li>
          <li>Android、Google Pay は、Google LLC の商標です。</li>
          <li>QUICPay+は、株式会社ジェーシービーの登録商標です。</li>
        </ul>
      </li>
      <li>
        <p class="owd-heading:05 spacing:bottom:16">ネットで支払いする場合の注意事項</p>
        <ul class="owd-list:annotation">
          <li>3Dセキュア（J/Secure™）とは、ネットショッピングでの第三者による不正利用を防ぐための「本人認証サービス」です。必要に応じて本人認証（パスワード認証）を行います。</li>
        </ul>
      </li>
      <li>
        <p class="owd-heading:05 spacing:bottom:16">デビットカード利用時の注意事項（お店・ネット共通）</p>
        <ul class="owd-list:annotation">
          <li>原則、利用時に普通預金口座から即時引落しとなりますが、一部の加盟店では後日払いとなるケースや差額引落しが発生するケースがあります。その際に口座残高が不足していた場合は、一定期間にわたり振替による引落しの手続きをさせていただきます。</li>
          <li>高速道路料金、ガソリンスタンド、機内販売、登録型加盟店（カード番号を登録し、継続的に利用額を支払いただく加盟店）など、一部利用できない加盟店があります。</li>
          <li>詳しくは<a href="/service/debit-card/summary/" class="owd-textlink">こちら</a>を確認してください。</li>
        </ul>
      </li>
    </ul>
  </section>



  <style lang="scss">
    .checkmark {
      &:before {
        background-image: url('/app/apptoweb/assets_default/icons/check_box.svg');
      }
    }

    a {
      &.owd-textlink {
        &\:blank {
          &:after {
            background-image: url(/app/apptoweb/assets_default/icons/arrow_launch.svg);
            background-position-y: 3px;
          }
        }
      }
    }

    * {
      font-size: inherit;
    }
  </style>
